/* ADD GROUPS */
export const LIST_REPORTA = "LIST_REPORTA"
export const LIST_REPORTA_SUCCESS = "LIST_REPORTA_SUCCESS"
export const LIST_REPORTA_CLEAN = "LIST_REPORTA_CLEAN"
export const LIST_REPORTA_ERROR = "LIST_REPORTA_ERROR"
